import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import withFieldError from 'components/form/with-error'
import { SelectPickerField } from 'components/form/selectpicker'
import { connect } from 'react-redux'
import CustomDmTemplate from '../send-facebook-blast/custom-template'

const selector = formValueSelector('widget')

export const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

export const FacebookOptOutRecurringFields = ({ selectedAction, name }) => (
  <div className='row select-group'>
    <div className='col-sm-4 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='TEMPLATE_GENERIC'
      >
        <option value='TEMPLATE_GENERIC'>Generic DM Template</option>
        <option value='TEMPLATE_CUSTOM'>Custom Template</option>
      </Field>
    </div>
    {selectedAction === 'TEMPLATE_GENERIC' && (
      <div className='col-sm-12'>
        <Field
          component={MessageInputWithError}
          label='Message'
          name={`${name}.fbOptOutRecurringAutoResponseText`}
          placeholder='Opt-out success auto response'
          require
        />
        <Field
          component={MessageInputWithError}
          label='Image URL'
          name={`${name}.fbOptOutRecurringAutoResponseImageUrl`}
          placeholder='Opt-out success Image URL'
        />
        <Field
          component={MessageInputWithError}
          label='Template Title'
          name={`${name}.templateTitle`}
          placeholder='Template Heading'
        />
        <Field
          component={MessageInputWithError}
          label='Template Action URL'
          name={`${name}.templateActionUrl`}
          placeholder='Template Action URL (where to go when user clicks on the notification message)'
        />
      </div>
    )}
    {selectedAction === 'TEMPLATE_CUSTOM' && (
      <div className='br-has-checkbox col-sm-12'>
        <Field component={CustomDmTemplate} name={`${name}.customDmTemplate`} />
      </div>
    )}
  </div>
)

FacebookOptOutRecurringFields.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string
}

const FacebookOptOutRecurringFieldsWithTypes = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`)
}))(FacebookOptOutRecurringFields)

export default FacebookOptOutRecurringFieldsWithTypes



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/facebook-optout-recurring/index.js